<template>
  <div class="header">
    <div :class="isLogged ? 'header__logo logged' : 'header__logo'" @click="goHome">
      <img class="header__logo__img" src="../assets/images/logo.png">
    </div>
    <div class="header__warning" v-if="isShowTag">
      <el-tag :closable="true" type="warning" effect="dark" @close="handleClose">每天运营时间 8:00-22:00, 早睡早起好身体！</el-tag>
    </div>
  </div>
</template>

<script>
  export default{
    name: 'AI-Head',
    data() {
      return {
        isLogged: this.$store.state.user.logged,
        isShowTag: true
      };
    },
    methods: {
      goHome(){
        if (this.isLogged){
          this.$router.push('/home', ()=>{})
        }
      },
      handleClose(){
        console.log('isShowTag', this.isShowTag)
        this.isShowTag = false
        console.log('isShowTag', this.isShowTag)
      }
    }
  }
</script>

<style lang="less" scoped>
.header {
  position: absolute;
  width: 100%;
  left: 0px;
  top: 0px;
  height: 64px;
  background-color: #3459e2;
  &__logo {
    position: absolute;
    display: flex;
    justify-content: center;
    text-align: center;
    left: 0px;
    top: 0px;
    width: 216px;
    height: 64px;
    &__img {
      margin-left: 40px;
      width: 70%;
      margin: 6px 0px;
      object-fit: contain;
    }
  }
  &__warning {
    position: absolute;
    top: 60px;
    right: 10px;
    font-size: 28px;
    cursor: pointer;
  }
}
.logged:hover{
  cursor: pointer; 
}
</style>